import type { PatientFormData, ToothData, PatientFieldConfig } from './types';

export const EMPTY_TOOTH: ToothData = { kemik: '', soket: '', greft: '', hacim: '', healing: '', implant_brand: '' };

export const PATIENT_FIELDS: PatientFieldConfig[] = [
  { key: 'operation_date', label: 'Tarih', type: 'date' },
  { key: 'patient_name', label: 'Hasta Adı', type: 'text' },
  { key: 'phone', label: 'Telefon', type: 'phone' },
  { key: 'clinic', label: 'Klinik', type: 'clinic' },
  {
    key: 'cinsiyet',
    label: 'Cinsiyet',
    type: 'options',
    options: [
      { value: 'k', label: 'K' },
      { value: 'e', label: 'E' },
    ],
  },
  {
    key: 'yas',
    label: 'Yaş',
    type: 'options',
    options: [
      { value: '1', label: '1' },
      { value: '2', label: '2' },
      { value: '3', label: '3' },
      { value: '4', label: '4' },
    ],
  },
  {
    key: 'seker',
    label: 'Şeker',
    type: 'options',
    options: [
      { value: '0', label: '0' },
      { value: '1', label: '1' },
      { value: '2', label: '2' },
    ],
  },
  {
    key: 'sigara',
    label: 'Sigara',
    type: 'options',
    options: [
      { value: '0', label: '0' },
      { value: '1', label: '1' },
      { value: '2', label: '2' },
    ],
  },
];

export const INITIAL_PATIENT_DATA: PatientFormData = {
  operation_date: '',
  patient_name: '',
  phone: '',
  clinic: '',
  cinsiyet: '',
  yas: '',
  seker: '',
  sigara: '',
};
